import { PdCheckbox } from "./pd-checkbox/PdCheckbox.js";
//#region src/pd-checkbox/pd-checkbox.ts
var tag = "pd-checkbox";
if (!customElements.get(tag)) customElements.define(tag, PdCheckbox);
//#endregion
export { PdCheckbox };
